"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _useUserData = _interopRequireDefault(require("./useUserData"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useParamsOrLocalStorage = function (context, key, defaultValue, isNumber, isRange, isBoolean) {
  if (isNumber === void 0) {
    isNumber = false;
  }
  if (isRange === void 0) {
    isRange = false;
  }
  if (isBoolean === void 0) {
    isBoolean = false;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const hasParams = urlParams.toString().length > 0;
  const [userData, setUserData] = (0, _useUserData.default)(context, key, defaultValue);
  const [value, setValue] = (0, _react.useState)(() => {
    const urlParam = new URLSearchParams(window.location.search).get(key);
    if (urlParam) {
      let params = urlParam.split(',');
      if (isNumber) params = params.map(id => Number(id));
      if (isRange) {
        if (params.length === 1) params = {
          periodicity: params[0]
        };
        if (params.length === 2) params = {
          min: Number(params[0]),
          max: Number(params[1])
        };
      }
      if (isBoolean) params = !!params[0];
      return params;
    }
    if (hasParams) return defaultValue;
    return userData;
  });
  const setKey = newValue => {
    if (!urlParams.get(key)) setUserData(newValue);
    setValue(newValue);
  };
  return [value, setKey];
};
var _default = exports.default = useParamsOrLocalStorage;